import React, { useState, useEffect } from 'react'
import styled, { withTheme } from 'styled-components'
import cn from 'classnames'
import { Layout } from '../../'
import { get, reduce, isUndefined } from 'lodash'
import { getSelectedMenuInfo } from '../../utils'
import HeaderNavs from '../HeaderNavs'
import Header from './Header'
import SideMenu from './SideMenu'
import CompactSideMenu from './CompactSideMenu'
import { getLanguageStore, getThemeStore } from '../storage'

const { Content, Sider } = Layout
const TNTPaasLayout = styled(Layout)`
  position: relative;
  height: 100vh;
  overflow: hidden;
  & > .ant-layout {
    flex-direction: row;
    & > .ant-layout-content {
      overflow-x: hidden;
      flex: 1;
    }
  }
  .tnt-layout-sider {
    overflow-x: hidden;
    background: #fff !important;
    box-shadow: 0 1px 10px 0 rgba(0, 0, 0, 0.1);
    z-index: 8;
  }
  &.isInIframe,
  &.isEmptyLayout {
    .tnt-layout-sider {
      display: none;
    }
  }
  &.tnt-themeS1 .tnt-layout-sider {
    background: #fff !important;
  }
  .tnt-layout-content {
    background: ${(props) => props.theme.lightBgColor};
  }
`
const noop = () => true

export default withTheme((props) => {
  const {
    appKey,
    logo,
    name,
    enName,
    isInIframe,
    isEmptyLayout,
    selectedAppKey,
    appList,
    config = {},
    extraHeaderActions,
    headerNavs,
    sideMenu,
    selectedMenuKey,
    menuAlignMode = 'side',
    menus = [],
    formatMenuPath,
    changeRouter,
    onLogoClick = noop,
    onThemeChange = noop,
    onLanguageChange = noop,
    onApplicationChange = noop,
    onAppChange = noop,
    onLogout,
    onBeforeMenuChange = noop,
    onMenuChange = noop,
    onMenuSelect = noop,
    onHeaderNavChange = noop,
  } = props
  const [userInfo, setUserInfo] = useState(props.userInfo || {})
  let theme = getThemeStore() || userInfo.theme || 'themeS2'
  // theme === 'default' ? 'themeS2' : theme;
  theme = ['default', 'themeS3'].includes(theme) ? 'themeS2' : theme

  const language = getLanguageStore() || userInfo.lang || 'cn'
  const menusMapByApp = menus.reduce((acc, menu) => {
    const subMenus = menu.children || []

    const singleGroupMap = subMenus.reduce((acc, subMenu) => {
      const { path } = subMenu
      const appKey = !/^http/i.test(path) ? path?.match(/\/([^\/]+)/)[1] : ''

      if (appKey) {
        acc[appKey] = acc[appKey] || {
          ...menu,
          children: [],
        }
        acc[appKey].children.push(subMenu)
      }
      return acc
    }, {})

    for (const appKey in singleGroupMap) {
      acc[appKey] = acc[appKey] || []
      acc[appKey].push(singleGroupMap[appKey])
    }

    return acc
  }, {})
  const [currentAppKey, setCurrentAppKey] = useState(appKey)
  const apps = reduce(
    menusMapByApp,
    (acc, value, key) => {
      acc.push({
        appKey: key,
        name: key,
      })
      return acc
    },
    []
  )

  const isMenusTop = menuAlignMode === 'top'
  let headerNavMenus = headerNavs
  const currentSystemMenus = menusMapByApp[currentAppKey] || []
  const [currentHeaderNavKey, setCurrentHeaderNavKey] = useState(get(currentSystemMenus, '0.code'))
  const sideMenus = isMenusTop
    ? get(
        currentSystemMenus.find(({ code }) => currentHeaderNavKey === code),
        'children',
        []
      )
    : currentSystemMenus
  const FinalSideMenu = isMenusTop ? CompactSideMenu : SideMenu

  // 一级菜单放在顶部(Header里面菜单作为一级导航)
  if (isMenusTop) {
    headerNavMenus = (
      <HeaderNavs
        selectedKey={currentHeaderNavKey}
        navs={currentSystemMenus.map((item) => ({
          ...item,
          key: item.code,
          name: item.groupName,
        }))}
        onChange={(item) => {
          setCurrentHeaderNavKey(item.key)
          onHeaderNavChange(item)
        }}
      />
    )
  }

  useEffect(() => {
    setUserInfo(props.userInfo)
  }, [props.userInfo])

  useEffect(() => {
    if (isMenusTop) {
      setCurrentHeaderNavKey(get(getSelectedMenuInfo(selectedMenuKey, menus), 'menu.code'))
    }
  }, [menus, selectedMenuKey])

  return (
    <TNTPaasLayout
      className={cn(`tnt-${theme} ${props.className || ''}`, {
        'large-size': props.theme.size === 'large',
        compatible: props.theme.compatible,
        isInIframe,
        isEmptyLayout,
        noAppList: !appList,
      })}
    >
      <Header
        logo={logo}
        name={name}
        enName={enName}
        language={language}
        theme={theme}
        userInfo={userInfo}
        config={config}
        appKey={currentAppKey}
        selectedAppKey={selectedAppKey}
        menus={menus}
        appList={appList}
        apps={apps}
        extraActions={extraHeaderActions}
        onLogoClick={onLogoClick}
        onAppChange={onAppChange}
        onThemeChange={(theme) => {
          setUserInfo({
            ...userInfo,
            theme,
          })
          onThemeChange && onThemeChange(theme)
        }}
        onLanguageChange={(lang) => {
          setUserInfo({
            ...userInfo,
            lang,
          })
          onLanguageChange && onLanguageChange(lang)
        }}
        onApplicationChange={(appKey) => {
          setCurrentAppKey(appKey)
          onApplicationChange(appKey)
        }}
        onLogout={onLogout}
      >
        {headerNavMenus}
      </Header>
      <Layout>
        {!isUndefined(sideMenu) ? (
          sideMenu
        ) : (
          <Sider breakpoint="md" className="tnt-layout-sider" width={220} trigger={null}>
            <FinalSideMenu
              language={language}
              selectedKey={selectedMenuKey}
              menus={sideMenus}
              formatMenuPath={formatMenuPath}
              changeRouter={changeRouter}
              onBeforeChange={onBeforeMenuChange}
              onChange={onMenuChange}
              onSelect={onMenuSelect}
            />
          </Sider>
        )}
        <Content className="tnt-layout-content">{props.children}</Content>
      </Layout>
    </TNTPaasLayout>
  )
})
